/**
 * @package soulgood-custom
 *
 * Entry point for Javascript package
 */

// Imports
require('./components/embed-player');
require('./components/font-switcher');
require('./components/slant-cover');

// Get main menu items
const mainMenuItems = <NodeListOf<HTMLLIElement>>document.querySelectorAll('.header__menu ul li');
// Calculate the middle one
const menuItemsCenter = Math.floor(mainMenuItems.length / 2 - 1);
// Get middle menu item
const middleMenuItem = mainMenuItems[menuItemsCenter];
// Add splitter class to middle list item
middleMenuItem.classList.add('splitter');

// Fix wp button classes
const wpBlockButtons = document.querySelectorAll('.wp-block-button');
wpBlockButtons.forEach((button) => {
  // Get the style classes
  const link = button.children[0];
  const classes = link.classList;

  // remove the main class
  classes.remove('wp-block-button__link');

  // Add style classes to parent button
  classes.forEach((className) => {
    button.classList.add(className);
  });

  // Remove style classes from button link
  link.setAttribute('class', 'wp-block-button__link');
});

// Button changer
const buttonElements = document.querySelectorAll('button');
buttonElements.forEach((button) => {
  const text = button.innerText;
  button.innerHTML = `<span>${text}</span>`;
});

// Form button changer
function checkContactForm() {
  // Look for the form button
  const formButton = <HTMLButtonElement>document.querySelector('.contactform button');

  if (!formButton) {
    // If not found, rerun function after timeout
    setTimeout(() => {
      checkContactForm();
    }, 150);

    // Exit the function
    return;
  }

  // Change the button to fit a span element
  const text = formButton.innerText;
  formButton.innerHTML = `<span>${text}</span>`;
}

// Init form checker
checkContactForm();
